import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useTheme } from "@/components/theme/ThemeProvider";
import { useAppName } from "@/hooks/useAppName";
import { resolveAppBranding } from "@/config/appBranding";
import { resolveLoginBackground } from "@/lib/loginBackground";
import { getPublicLoginBackgrounds } from "@/services/loginAppearanceService";

export function LoginBackground() {
  const detectedAppName = useAppName();
  const params = new URLSearchParams(window.location.search);
  const hostApp = window.location.hostname === "app.vb20tunisie.com" ? "VB20TN"
    : window.location.hostname === "mpilates.stryvfit.app" ? "Maison Pilates" : null;
  const appName = resolveAppBranding(params.get("app") ?? params.get("appName") ?? hostApp ?? detectedAppName).key;
  const { theme } = useTheme();
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const { data } = useQuery({
    queryKey: ["public-login-backgrounds", appName],
    queryFn: () => getPublicLoginBackgrounds(appName),
    enabled: appName !== "StriFit",
    staleTime: 0,
    retry: 1,
  });
  const src = resolveLoginBackground(appName, theme, data);
  if (!src || src === failedUrl) return null;
  return <><img key={src} src={src} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover pointer-events-none" onError={() => setFailedUrl(src)} /><div className="login-background-overlay absolute inset-0 pointer-events-none" /></>;
}